import { render, staticRenderFns } from "./MarkList.vue?vue&type=template&id=3ecc7463&scoped=true"
import script from "./MarkList.vue?vue&type=script&lang=js"
export * from "./MarkList.vue?vue&type=script&lang=js"
import style0 from "./MarkList.vue?vue&type=style&index=0&id=3ecc7463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc7463",
  null
  
)

export default component.exports